import React from 'react';
import Pill from 'components/Pill';
import Time from 'components/Time';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LastestInteractionPill(_ref) {
  var latestInteraction = _ref.latestInteraction;
  return /*#__PURE__*/_jsx(Pill, {
    children: /*#__PURE__*/_jsx(Time, {
      dateTime: latestInteraction
    })
  });
}